import { INameIdObj } from '../shared/fi-shared-interfaces';
import { SortType } from '../shared/types';

export const SiteMapSortingTypes: INameIdObj[] = [
    {
        Id: SortType.Chronological,
        Name: 'common.chrono',
    },
    {
        Id: SortType.ReversedChronological,
        Name: 'common.reverse_chrono',
    },
    {
        Id: SortType.Alphabetical,
        Name: 'common.alphabetical',
    },
    {
        Id: SortType.ReversedAlphabetical,
        Name: 'common.reversed_alphabetical',
    },
];
